import React, { useEffect, useState } from 'react';

export default function ThemeToggle() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('entremap-theme') || 'light'
  );

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('entremap-theme', theme);
  }, [theme]);

  return (
    <button
      onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
      style={{
        border: '1px solid var(--ad-border)',
        background: 'var(--ad-surface)',
        color: 'var(--ad-text)',
        borderRadius: 12,
        padding: '8px 12px',
        width: '100%',
        cursor: 'pointer'
      }}
      aria-label="Toggle theme"
      title="Toggle theme"
    >
      {theme === 'light' ? '🌙 Dark mode' : '☀️ Light mode'}
    </button>
  );
}
